export const knownPersonaColumns = [
  'name',
  'age_bracket',
  'socio_economic_status',
  'weight',
  'past_weightloss_interventions',
  'mental_wellbeing',
  'neurodiversity',
  'physical_health_condition',
  'quality_of_sleep',
  'profession',
  'favourite_food',
  'level_of_engagement',
  'locus_of_control',
  'mindset_flexibility',
  'habit_change_knowledge',
  'self_efficacy',
  'eating_control',
  'emotional_regulation',
  'supportive_environment',
  'interaction_directions',
  'reasons_for_chatting',
  'short_tag',
  'english_dialect',
  'gender',
];
